import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapModel3DSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapmodel3d: {
      group: 'inline',
      inline: true,
      attrs: {
        src: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:model3D',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['src']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:model3D',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
